import {
  bhSpecificDefaultItems,
  defaultItems,
  defaultItemsSmartChoice,
  dentalSpecificDefaultItems,
  visionSpecificDefaultItems,
} from '../../MapView/CompareDrawer/utility/compareDrawerConstants';

export const getDefaultCompareAttributes = (coverageType: string, compareSmartChoice?: boolean) => {
  let compareAttributeItems;
if(compareSmartChoice) return defaultItemsSmartChoice
  switch (coverageType) {
    case 'B':
      compareAttributeItems = bhSpecificDefaultItems;
      break;
    case 'V':
      compareAttributeItems = visionSpecificDefaultItems;
      break;
    case 'D':
      compareAttributeItems = dentalSpecificDefaultItems;
      break;
    default:
      compareAttributeItems = defaultItems;
      break;
  }

  return compareAttributeItems;
};
